export const getUrlPath = (fullUrl) => fullUrl
    .split('/')
    .slice(3)
    .join('/');
